<template>
    <div class="developForum">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>

        <!-- 主体 -->
        <div class="main">
            <div class="left">
                <div class="tab">
                    <span>您所在的位置：</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item>{{ documentTitle }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="content">
                    <div><img src="../../assets/img/index/CXGheader.png" alt="" style="width: 100%;"></div>
                    <div class="menuTab">
                        <div class="top">
                            <span v-for="(item, index) in menuTabList" :key="index" @click="jump(item)">{{ item.name }}</span>
                        </div>
                    </div>

                    <div class="publicity">
                        <img src="../../assets/img/index/forumIndex.png" alt="" style="width: 100%;">
                        <div class="text">
                            <!-- <div>守信践诺 构建共同发展新未来</div> -->
                            <div style="text-indent:2em;height: 104px;overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 4;
                            -webkit-box-orient: vertical;" v-html="detail.content"></div>
                            <div style="text-align: right;"><i style="color: #1A68E8;cursor: pointer;" @click="todetail(detail, '通知文件')">查看全文 >></i></div>
                        </div>
                    </div>

                    <div class="footBottom">
                        <div class="left">
                            <div class="top">
                                <div class="forumTitle">
                                    <div style="font-size: 20px;color: #fff;">信用发展论坛</div>
                                </div>
                                <div class="publicTop"></div>
                                <div class="list">
                                    <ul>
                                        <li v-for="(item, index) in forumList" :key="index">
                                            <div class="img">
                                                <img :src="baseUrl + item.coverImg" alt="" @error="imgError">
                                            </div>
                                            <div style="text-align: center;padding: 20px 0;color: #000;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;">{{ item.title }}</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../../api/api'
import { decrypt } from '../../utils/decode'
import publicHeaders from '../../components/header.vue'
import foot from '../../components/foot.vue'
import {baseURL} from '../../api/network.js';
export default {
    name: 'developForum',
    components: {
        publicHeaders,
        foot
    },
    data() {
        return {
            documentTitle: '',
            baseUrl: baseURL,
            menuTabList: [
                {
                    name: '首页',
                    title: '全国企业诚信建设示范基地',
                    url: '/developForum'
                },
                {
                    name: '通知文件',
                    title: '通知文件',
                    url: '/forum_detail'
                },
                {
                    name: '领导嘉宾',
                    title: '领导嘉宾',
                    url: '/forum_detail'
                },
                {
                    name: '活动议程',
                    title: '活动议程',
                    url: '/forum_detail'
                },
                {
                    name: '宣传报道',
                    title: '宣传报道',
                    url: '/forum_list'
                },
                {
                    name: '参会申请',
                    title: '参会申请',
                    url: '/forum_detail'
                },
                {
                    name: '往届回顾',
                    title: '往届回顾',
                    url: '/forum_list'
                },
            ],
            forumList: [
                // {
                //     imgUrl: require('../../assets/img/index/rectangle.png'),
                //     name: '王新星  北京广播电视台主持人'
                // },
                // {
                //     imgUrl: require('../../assets/img/index/rectangle.png'),
                //     name: '王新星  北京广播电视台主持人'
                // },
                // {
                //     imgUrl: require('../../assets/img/index/rectangle.png'),
                //     name: '王新星  北京广播电视台主持人'
                // },
                // {
                //     imgUrl: require('../../assets/img/index/rectangle.png'),
                //     name: '王新星  北京广播电视台主持人'
                // },
            ],
            detail: {}
        }
    },
    created() {
        this.documentTitle = this.$route.query.documentTitle
        document.title = this.$route.query.documentTitle

        this.getTopArticle()
        this.getForumList()
    },
    mounted() {
    },
    methods: {
        jump(item) {
            if (item.url != '') {
                this.$router.push({
                    path: item.url,
                    query: {
                        documentTitle: item.title
                    }
                })
                // let routeUrl = this.$router.resolve({
                //   path: item.url
                // });
                // // console.log(routeUrl);
                // window.open(routeUrl.href+ '?documentTitle=' + item.title, '_blank');
            }
        },

        // 获取相关文章
        getTopArticle() {
            let _this = this
            let params = {
                cateId: 50,
                title: '',
                page: 1,
                size: 20,
            }
            api.getList(params).then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    if (data.data.data.length != 0) {
                        _this.getArticleInfo(data.data.data[0].id)
                    }
                    // _this.box2List = data.data.data
                } else {
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 获取文章详情
        getArticleInfo(id) {
            let _this = this
            _this.detail = {}
            let params = {
                id: id,
            }
            api.getInfo(params).then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    _this.detail = data.data
                } else {
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 获取信用发展论坛
        getForumList() {
            let _this = this
            let params = {
                cateId: 62,
                title: '',
                page: 1,
                size: 12,
            }
            api.getList(params).then(res => {
                let { data } = res
                // console.log(data);
                if (data.status == 200) {
                    _this.forumList = data.data.data
                } else {
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 查看全文跳转
        todetail(item, title) {
            this.$router.push({
                name: 'forum_detail',
                query: {
                    documentTitle: title,
                    id: item.id
                }
            })
            // let routeUrl = this.$router.resolve({
            //       path: '/forum_detail'
            //     });
            //     // console.log(routeUrl);
            //     window.open(routeUrl.href+ '?documentTitle=' + title + '&id=' + item.id, '_blank');
        },

        imgError(e) {
            var img = e.srcElement;
            // console.log(img);
            img.src = require('../../assets/img/index/rectangle.png');
            img.onerror = null; //控制不要一直跳动 
        },
    }
}
</script>

<style lang="less" scoped>
.developForum {
    position: relative;
    padding-bottom: 140px;
    .main {
        width: 80%;
        padding: 15px 50px;
        margin: 0 auto;
        @media only screen and (min-width: 769px) {
            min-width: 1152px;
        }
        .left {
            .tab {
                background-color: #F2F2F2;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 5px 10px;
            }
            .content {
                min-height: 600px;
                margin-top: 10px;
                .menuTab {
                    margin-top: 15px;
                    color: #134AA6;
                    padding: 0 100px;
                    background-color: #E8F1FF;
                    .top {
                        padding: 10px 0;
                        display: flex;
                        span {
                            flex: 1;
                            cursor: pointer;
                            text-align: center;
                        }
                        span:nth-of-type(n+2) {
                            border-left: 1px solid #98C8F8;
                        }
                    }
                }
                .publicity {
                    margin-top: 15px;
                    position: relative;
                    .text {
                        position: absolute;
                        bottom: -78px;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 100%;
                        height: 154px;
                        border: 1px solid #1A68E8;
                        background-color: #fff;
                        padding: 20px;
                        color: #666;
                        line-height: 26px;
                        padding-top: 15px;
                    }
                }
                .footBottom {
                    min-height: 200px;
                    margin-top: 100px;
                    display: flex;
                    justify-content: space-between;
                    .left {
                        width: 77%;
                        .publicTop {
                            height: 46px;
                            border-bottom: 1px solid #85B2FF;
                            background: linear-gradient(to bottom, #EAF6FF, #ECF7FF, #DEF0FF, #E9F5FF, #F6FBFF);
                        }
                        .top {
                            height: 873px;
                            border: 1px solid #5797FF;
                            position: relative;
                            .forumTitle {
                                position: absolute;
                                left: -1px;
                                top: -11px;
                                width: 175px;
                                height: 57px;
                                background: url('../../assets/img/index/forumTitle.png') no-repeat;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                padding-right: 10px;
                            }
                            .list {
                                padding: 20px 15px; 
                                ul {
                                    overflow: hidden;
                                }
                                li {
                                    float: left;
                                    width: 24%;
                                    margin: 5px;
                                    padding-bottom: 5px;
                                    // cursor: pointer;
                                    .img {
                                        padding: 5px;
                                        border: 1px solid #D9D9D9;
                                        img {
                                            width: 100%;
                                            /* height: 175px; */
                                            object-fit: contain;
                                        }
                                    }
                                }
                            }
                        }
                        .bottom {
                            height: 335px;
                            border: 1px solid #5797FF;
                            position: relative;
                            margin-top: 25px;
                            .forumTitle {
                                position: absolute;
                                left: -1px;
                                top: -11px;
                                width: 175px;
                                height: 57px;
                                background: url('../../assets/img/index/forumTitle.png') no-repeat;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                padding-right: 10px;
                            }
                            .list {
                                padding: 20px 15px; 
                                ul {
                                    overflow: hidden;
                                    li {
                                        float: left;
                                        width: 24%;
                                        margin: 5px;
                                        padding-bottom: 5px;
                                        .img {
                                            padding: 5px;
                                            border: 1px solid #D9D9D9;
                                            img {
                                                width: 100%;
                                                /* height: 175px; */
                                                object-fit: contain;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .right {
                        width: 23%;
                    }
                }
            }
        }
    }
}
</style>
